<template>
  <modal
    ref="exportConsumer"
    :scrollable="false"
    cancel-title="Zrušiť"
    centered
    name="export-consumer"
    ok-title="Exportovať"
    title="Exportovať"
    @hidden="Object.assign($data, $options.data())"
    @ok="exportConsumer"
    @show="getGroups"
  >
    <b-overlay :blur="null" :show="loading" class="h-100" opacity="0">
      <transition mode="out-in" name="fadeShort">
        <div v-if="!loading">
          <div>
            <b-form-group label="Komodita" label-cols-sm="5" label-for="type">
              <b-form-select v-model="exportData.typeID" :select-size="1">
                <option :value="1">Elektrina</option>
                <option :value="2">Plyn</option>
                <option :value="3">Voda</option>
                <option :value="4">Teplo</option>
              </b-form-select>
            </b-form-group>
            <b-form-group label="Rok" label-cols-sm="5" label-for="year">
              <b-form-select v-model="exportData.year" :select-size="1">
                <option v-for="year in exportYears" :key="year" :value="year">
                  {{ year }}
                </option>
              </b-form-select>
            </b-form-group>
            <b-form-group label="Skupina" label-cols-sm="5" label-for="group">
              <selectbox
                v-model="exportData.group_id"
                :close-on-select="false"
                :group-select="true"
                :options="customerGroups"
                group-label="group"
                group-values="values"
                multiple
                placeholder="Vyberte skupinu"
                searchable
              >
                <template slot="selection" slot-scope="{ values }">
                  <span class="multiselect__single"
                    >{{ values.length }} vybraných</span
                  >
                </template>
                <template slot="noResult"> Skupina nenájdená </template>
              </selectbox>
            </b-form-group>
            <b-form-group label="" label-cols-sm="5" label-for="inactives">
              <b-form-checkbox
                v-model="exportData.inactives"
                :unchecked-value="0"
                :value="1"
              >
                Exportovať neaktívne
              </b-form-checkbox>
            </b-form-group>
            <b-form-group label="" label-cols-sm="5" label-for="inactives_only">
              <b-form-checkbox
                v-model="exportData.inactives_only"
                :unchecked-value="0"
                :value="1"
              >
                Iba neaktívne
              </b-form-checkbox>
            </b-form-group>
          </div>
        </div>
      </transition>
    </b-overlay>
  </modal>
</template>
<script>
import Modal from '@/components/Modal'
import Selectbox from '@/components/inputs/Selectbox'
import moment from 'moment'
import { saveAs } from 'file-saver'

export default {
  components: {
    Modal,
    Selectbox,
  },
  data() {
    return {
      loading: false,
      customerGroups: [
        {
          group: '-Všetky skupiny-',
          values: [],
        },
      ],
      exportData: {
        typeID: 1,
        year: moment().year(),
        group_id: [],
        inactives: 0,
        inactives_only: 0,
      },
    }
  },
  computed: {
    exportYears() {
      return this.$helpers.datesBetween(
        [this.$moment(2015, 'YYYY'), this.$moment()],
        'years',
        'YYYY',
        'desc',
      )
    },
  },
  methods: {
    getGroups() {
      this.loading = true
      this.$api.get('customers/get_groups').then((res) => {
        this.customerGroups[0].values = res.data.data
        this.loading = false
      })
    },
    exportConsumer(e) {
      e.preventDefault()
      this.$swal({
        toast: true,
        type: 'info',
        position: 'top-end',
        title: 'Pripravujem export...',
      })
      this.$api
        .get('reports/consumer/export', {
          params: this.exportData,
          responseType: 'blob',
        })
        .then((res) => {
          let type = ''
          switch (this.exportData.typeID) {
            case 1:
              type = 'elektrina'
              break
            case 2:
              type = 'plyn'
              break
            case 3:
              type = 'voda'
              break
            case 4:
              type = 'teplo'
              break
          }
          saveAs(new Blob([res.data]), 'spotrebny-report_' + type + '.xlsx')
          this.$root.$emit('modal-hide', 'export-consumer')
          this.$swal({
            toast: true,
            type: 'success',
            position: 'top-end',
            title: 'Export pripravený',
            timer: 5000,
          })
        })
        .catch(() => {
          this.$swal({
            toast: true,
            type: 'error',
            position: 'top-end',
            title: 'Chyba pri exportovaní',
            timer: 5000,
          })
        })
    },
  },
}
</script>
